module.exports = __webpack_public_path__ + "static/media/get_started.7699b6bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/get_started.svg
// module id = 172
// module chunks = 0